module.exports = __webpack_public_path__ + "img/motorcycle_racing.502119f.png";